<!-- 多供应商采购>库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main multi-supplier-purchase">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase"
                    @click="gotoQuickBuy()">{{ permission.stockPurchase }}</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase_h"
                    @click="gotoQuickBuy_h()">{{ permission.stockPurchase_h }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">汽配编码、互换码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode"
                    placeholder="汽配编码、互换码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName"
                    placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise"
                    placeholder="适用车型"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select v-model="searchData.BrandName" filterable clearable size="small"
                        @visible-change="brandVisibleChange($event)" style="width: 100%">
                        <el-option label="全部" value></el-option>
                        <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 100%" v-model="searchData.Cate" filterable clearable
                        @visible-change="classifyVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text"
                            :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                    @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary"
                    @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%"
                    :cell-style="cellStyle" @selection-change="handleSelectionChange" @cell-dblclick="handleDBClick"
                    @sort-change="sortChange">
                    <el-table-column fixed type="selection" width="55"></el-table-column>
                    <el-table-column min-width="150px" prop="LatelyPurchase.EntpCusName" label="供应商"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column width="200px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                    <el-table-column width="130px" label="产地" prop="Origin"></el-table-column>
                    <el-table-column width="90px" prop="CostPrice" label="成本价" show-overflow-tooltip>
                        <template slot="header">
                            <el-tooltip effect="dark" placement="bottom">
                                <div slot="content">
                                    当配件已采购过时，{{ isLatelyPrice ? '显示配件最低供应商的最新采购价格；' : '显示配件供应商的最低采购价格；' }}<br />
                                    若配件从未采购过，则显配件成本价格
                                </div>
                                <span>
                                    <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                </span>
                            </el-tooltip>
                            成本价
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.LatelyPurchase ? scope.row.LatelyPurchase.Price : scope.row.CostPrice }}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="80px" prop="Price" label="批发价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="MarketPrice" label="零售价"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="UpperLimit" label="上限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="LowerLimit" label="下限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="Inventory" label="库存" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="PlanPurchase" label="计划数"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column width="70px" prop="NeedIn" label="待入"></el-table-column>
                    <el-table-column width="70px" prop="NeedOut" label="待出"></el-table-column>
                    <el-table-column width="70px" label="留余">
                        <template slot-scope="scope">
                            <i class="out-active">{{ scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ?
                                scope.row.NeedIn : 0) }}</i></template></el-table-column>
                    <el-table-column min-width="100px" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120" prop="Brand" label="品牌" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Unit" label="单位" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Quality" label="重量" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Size" label="尺寸" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Texture" label="材质" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Color" label="颜色" show-overflow-tooltip
                        sortable="custom"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img v-if="scope.row.LatelyPurchase" class="image-sup" src="@/assets/images/sup.png"
                                    title="采购历史"
                                    @click="showHistories(scope.row.EntpTempGoodsId, scope.row.LatelyPurchase)" />
                                <img class="image-cus" src="@/assets/images/cus.png" title="销售历史"
                                    @click="showSaleStat(scope.row, scope.row.LatelyPurchase)" />
                                <img src="@/assets/images/analysis.png" style="width: 22px; height: 22px; margin-left: 6px"
                                    title="数据分析" @click="analysis(scope.row)" />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="closeAPMsgDialog">
                </APMsg>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory :EntpTempGoodsId="EntpTempGoodsId" :EntpCusId="EntpCusId" :EntpCusName="EntpCusName"
                    @closeDialog="closeHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body
            width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsId"
                    @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="EntpTempGoodsId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import APMsg from '@/components/common/APMsg';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        elTableColumn,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis,
        breadcrumb
    },
    data() {
        return {
            multipleSelection: [],
            brand: [],
            noData: false,
            typeList: [],
            goodsType: '',
            APMsgVisible: false,
            EntpTempGoodsId: '',
            showSaleStatDialog: false,
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            historyVisible: false,
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            isAddWaitIn: true,
            EntpCusId: '',
            EntpCusName: '',
            isLatelyPrice: false
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getConfigByCodes();
        this.getTableData();
        this.permission = this.$util.getPermission('multiSupplierPurchase');
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 单元格的 style 的回调方法
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label === '操作') {
                return `background:#FFF;`;
            } else {
                return '';
            }
        },
        // 跳转直接采购
        gotoQuickBuy() {
            if (!this.multipleSelection[0]) {
                // this.$util.warningMsg("请选择汽配");
                this.$router.push('/purchaseManage/multiSupplierPurchaseEdit');
                return;
            }
            let dataList = [];
            for (var i = 0; i < this.multipleSelection.length; i++) {
                let data = { ...this.multipleSelection[i] };
                data.Price = data.CostPrice; //字段转化，方便编辑页面处理
                if (data.LatelyPurchase) {
                    data.EntpCusId = data.LatelyPurchase.EntpCusId;
                    data.EntpCusName = data.LatelyPurchase.EntpCusName;
                    data.EntpCusItem = data.LatelyPurchase.EntpCusName;
                    data.LatelyPrice = data.LatelyPurchase.Price;
                    data.Price = data.LatelyPurchase.Price > 0 ? data.LatelyPurchase.Price : data.Price;
                    this.$delete(data, 'LatelyPurchase');
                } else {
                    data.EntpCusId = '';
                    data.EntpCusName = '';
                    data.EntpCusItem = '';
                    data.LatelyPrice = 0;
                }
                data.Count = 1;
                data.GoodNameItem = data.GoodName;
                data.AutoSeriseItem = data.AutoSerise;
                dataList.push(data);
            }
            this.$util.setLocalStorage('AddMultiSuPurOrders_dataList', dataList);
            this.$router.push('/purchaseManage/multiSupplierPurchaseEdit');
        },
        gotoQuickBuy_h() {
            if (!this.multipleSelection[0]) {
                this.$router.push('/purchaseManage/multiSupplierPurchaseEdit_h');
                return;
            }
            let dataList = [];
            for (var i = 0; i < this.multipleSelection.length; i++) {
                let data = { ...this.multipleSelection[i] };
                data.Price = data.CostPrice; //字段转化，方便编辑页面处理
                if (data.LatelyPurchase) {
                    data.EntpCusId = data.LatelyPurchase.EntpCusId;
                    data.EntpCusName = data.LatelyPurchase.EntpCusName;
                    data.EntpCusItem = data.LatelyPurchase.EntpCusName;
                    data.LatelyPrice = data.LatelyPurchase.Price;
                    data.Price = data.LatelyPurchase.Price > 0 ? data.LatelyPurchase.Price : data.Price;
                    this.$delete(data, 'LatelyPurchase');
                } else {
                    data.EntpCusId = '';
                    data.EntpCusName = '';
                    data.EntpCusItem = '';
                    data.LatelyPrice = 0;
                }
                data.Count = 1;
                data.GoodNameItem = data.GoodName;
                data.AutoSeriseItem = data.AutoSerise;
                dataList.push(data);
            }
            this.$util.setLocalStorage('AddMultiSuPurOrders_dataList', dataList);
            this.$router.push('/purchaseManage/multiSupplierPurchaseEdit_h');
        },

        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => { });
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => { });
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 选中汽配分类
        chooseNode(data) {
            if (data) {
                this.goodsType = data.Item.Name;
                this.searchData.CascadeId = data.Item.CascadeId;
            } else {
                this.goodsType = '';
                this.searchData.CascadeId = '';
            }
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetMultiSupplierPurPartList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => { });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.EntpTempGoodsId = event.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        gotoOldVers() {
            this.$router.push('/purchaseManage/stockPurchase');
        },
        //销售数据
        showSaleStat(row, LatelyPurchase) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                if (LatelyPurchase) {
                    this.EntpCusId = LatelyPurchase.EntpCusId;
                    this.EntpCusName = LatelyPurchase.EntpCusName;
                } else {
                    this.EntpCusId = '';
                    this.EntpCusName == '';
                }
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 历史销售
        showHistories(id, LatelyPurchase) {
            if (id) {
                this.EntpTempGoodsId = id;
                if (LatelyPurchase) {
                    this.EntpCusId = LatelyPurchase.EntpCusId;
                    this.EntpCusName = LatelyPurchase.EntpCusName;
                } else {
                    this.EntpCusId = '';
                    this.EntpCusName == '';
                }
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        getConfigByCodes() {
            let codes = ['lybsdr', 'dgystjqzdjg'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'dgystjqzdjg': //是否只取相同最低价格取最新供应商（返回最低价格）
                                this.isLatelyPrice = result;
                                break;
                        }
                    }
                }
            });
        },
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;

    p {
        padding-top: 10px;
    }
}

.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}

.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}

.qp-cover {
    text-align: center;
    overflow: hidden;

    img {
        max-height: 218px;
        max-width: 218px;
    }
}

.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }

    .image-cus {
        width: 25px;
        height: 25px;
    }
}

@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}

@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.multi-supplier-purchase {
    .el-table {

        .hover-row>td,
        .el-table__row:hover>td {
            background-color: #dcdee1;
        }
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-table .error-row {
        background: rgb(255, 176, 176);
    }
}
</style>
